import * as React from 'react';

import { ErrorLayout } from './ErrorLayout';
import image from '../assets/warning.png';

interface IReviewTimeLimitAfterTripExceededErrorProps {
  onClose(): void;
}

export const ReviewTimeLimitAfterTripExceededError: React.FC<IReviewTimeLimitAfterTripExceededErrorProps> = ({
  onClose,
}) => {
  return (
    <ErrorLayout
      image={image}
      title="Оставить отзыв не&nbsp;получится"
      description={
        <>
          Написать отзыв можно в&nbsp;течение 14&nbsp;дней после&nbsp;выезда.
          <br />
          Будем рады, если&nbsp;поделитесь впечатлением о&nbsp;следующей поездке.
        </>
      }
      actions={[{ label: 'Понятно, спасибо', onClick: onClose }]}
    />
  );
};
